// extracted by mini-css-extract-plugin
module.exports = {"App":"src_App__3fm-p"};